import type { TranslationInterface } from './translation.types';

export const arLocale: TranslationInterface = {
  'write-a-message': 'اكتب رسالة...',
  'session-closed-lead': 'تم حل مشكلتك!',
  'new-conversation': 'محادثة جديدة',
  'welcome-title': 'مرحبًا بك في دردشة الدعم الخاصة بنا',
  'welcome-description':
    'نحن هنا للمساعدة! ابدأ محادثة وسنرد عليك في أقرب وقت ممكن.',
  'your-name': 'اسمك',
  'your-email': 'عنوان بريدك الإلكتروني',
  'start-chat': 'تحدث إلى الدعم',
  'starting-chat': 'جاري الاتصال...',
  'i-need-more-help': 'أحتاج المزيد من المساعدة',
  'this-was-helpful': 'كان هذا مفيدًا',
  optional: 'اختياري',
  'no-conversations-yet': 'لا يوجد محادثات',
  'back-to-conversations': 'العودة إلى المحادثات',
  'closed-conversations': 'المحادثات المغلقة',
};
